<template>
  <div class="dashboard-wrapper" v-if="serverData.length">
    <div class="row">
      <div class="col-12" v-for="(item, index) in serverData" :key="index">
        <div class="pa-4 h-100 px-9 py-5 shadow-sm rounded-lg bg-white">
          <v-card-title class="text-h6 font-weight-bold ps-0 card-title">
            {{ item[0].title }}
          </v-card-title>

          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th
                    v-for="(header, index1) in item[0].headers"
                    :key="index1"
                    scope="col"
                    class=""
                  >
                    {{ header.charAt(0).toUpperCase() + header.slice(1) }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-if="item[0].counters.length">
                  <tr
                    v-for="(counter, index2) in item[0].counters"
                    :key="index2"
                  >
                    <td
                      v-for="(key, ind) in counter"
                      :key="ind"
                      class="font-weight-medium text-dark-50 border-bottom-dashed"
                    >
                      {{ key }}
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <td
                    class="font-weight-medium text-dark-50"
                    colspan="12"
                    style="padding-top: 2.5rem; text-align: center"
                  >
                    No data available
                  </td>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardOperationGroupNew",
  props: ["serverData"],
  computed: {
    headers() {
      return [
        { text: "Title", value: "title" },
        { text: "SDD", value: "sdd" },
        { text: "NDD", value: "ndd" },
        { text: "B2B", value: "b2b" },
      ];
    },
  },
  methods: {
    getBorderClass(index, length) {
      return index < length - 1 ? "border-bottom-dashed" : "";
    },
  },
};
</script>

<style scoped lang="scss">
.dashboard-wrapper {
  padding: 1rem;

  @media (min-width: 768px) {
    padding: 2rem;
  }
}

/* Optional: custom table tweaks */
.custom-table {
  thead {
    background-color: #f5f5f5;
    font-weight: 600;
  }
  td {
    font-size: 0.9rem;
  }
}

.table {
  thead {
    tr {
      th {
        border-bottom: 2px dashed #ebedf3 !important;
        color: #c9cdd9 !important;
        font-size: 14px !important;
      }
    }
  }
  tbody {
    tr {
      td,
      th {
        font-size: 14px !important;
      }
    }
  }
}

.border-bottom-dashed {
  border-bottom: 1px dashed #ebedf3 !important;
}
.card-title {
  color: #7e8299 !important;
}
</style>
